import React, { useState } from 'react';
import { Tooltip as ReactStrapTooltip } from 'reactstrap';
import { v4 } from 'uuid';

import './Tooltip.css';

const Tooltip = ({ label, id, placement = 'top' }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);

    const content = React.useMemo(() => {
        const doc = new DOMParser().parseFromString(label, 'text/html');
        return doc.body.textContent || '';
    }, [label]);

    if (!label)
        return null;

    return (
        <>
            <i id={id} className="fa fa-info-circle" />
            <ReactStrapTooltip
                placement={placement}
                isOpen={tooltipOpen}
                target={id}
                toggle={toggle}
            >
                { content }
            </ReactStrapTooltip>
        </>
    );
}

export default Tooltip;
